import { createApiSlice } from "@common";
import {
  GET_SALES_EXECUTIVE_ACTIVITIES_COMPLETED_THIS_WEEK,
  GET_SALES_EXECUTIVE_DASHBOARD_SUMMARY,
  GET_SALES_EXECUTIVE_LEAD_DISTRIBUTION,
  GET_SALES_EXECUTIVE_LEAD_DISTRIBUTION_DETAILS,
  GET_SALES_EXECUTIVE_OPPORTUNITY_VALUE_BY_STAGE,
  GET_SALES_EXECUTIVE_PRIORITY_WORK_QUEUE,
} from "@routes";

// Define API config array for Dashboard summary and charts
const apiConfig = [
  {
    name: "getSalesExecutiveDashboardSummary",
    method: "get",
    url: GET_SALES_EXECUTIVE_DASHBOARD_SUMMARY,
    stateKey: "summary",
  },
  {
    name: "getSalesExecutiveOpportunityValueByStage",
    method: "get",
    url: GET_SALES_EXECUTIVE_OPPORTUNITY_VALUE_BY_STAGE,
    stateKey: "opportunityValueByStage",
  },
  {
    name: "getSalesExecutivePriorityWorkQueue",
    method: "get",
    url: GET_SALES_EXECUTIVE_PRIORITY_WORK_QUEUE,
    stateKey: "priorityWorkQueue",
  },
  {
    name: "getSalesExecutiveLeadDistribution",
    method: "get",
    url: GET_SALES_EXECUTIVE_LEAD_DISTRIBUTION,
    stateKey: "leadDistribution",
  },
  {
    name: "getSalesExecutiveLeadDistributionDetails",
    method: "get",
    url: GET_SALES_EXECUTIVE_LEAD_DISTRIBUTION_DETAILS,
    stateKey: "leadDistributionDetails",
  },
  {
    name: "getSalesExecutiveActivitiesCompletedThisWeek",
    method: "get",
    url: GET_SALES_EXECUTIVE_ACTIVITIES_COMPLETED_THIS_WEEK,
    stateKey: "activitiesCompletedThisWeek",
  },
];

// Define custom initial state and reducers
const customReducers = {
  initialState: {
    loading: false,
    summary: null,
    opportunityValueByStage: null,
    priorityWorkQueue: null,
    leadDistribution: null,
    leadDistributionDetails: null,
    activitiesCompletedThisWeek: null,
    filters: {
      fromDate: "",
      toDate: "",
      currencyCode: "",
      timezone: "",
    },
  },
  reducers: {
    setDashboardSummary: (state, action) => {
      state.summary = action.payload;
    },
    setOpportunityValueByStage: (state, action) => {
      state.opportunityValueByStage = action.payload;
    },
    setPriorityWorkQueue: (state, action) => {
      state.priorityWorkQueue = action.payload;
    },
    setLeadDistribution: (state, action) => {
      state.leadDistribution = action.payload;
    },
    setLeadDistributionDetails: (state, action) => {
      state.leadDistributionDetails = action.payload;
    },
    resetLeadDistributionDetails: (state) => {
      state.leadDistributionDetails = null;
    },
    setActivitiesCompletedThisWeek: (state, action) => {
      state.activitiesCompletedThisWeek = action.payload;
    },
    setDashboardFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    resetDashboardFilters: (state) => {
      state.filters = {
        fromDate: "",
        toDate: "",
        currencyCode: "",
        timezone: "",
      };
    },
  },
};

// Generate the slice, thunks, and actions using the common utility
const { slice, thunks, actions } = createApiSlice(
  "dashboard",
  apiConfig,
  customReducers
);

export const {
  getSalesExecutiveDashboardSummary,
  getSalesExecutiveOpportunityValueByStage,
  getSalesExecutivePriorityWorkQueue,
  getSalesExecutiveLeadDistribution,
  getSalesExecutiveLeadDistributionDetails,
  getSalesExecutiveActivitiesCompletedThisWeek,
} = thunks;
export const {
  setDashboardSummary,
  setOpportunityValueByStage,
  setPriorityWorkQueue,
  setLeadDistribution,
  setLeadDistributionDetails,
  resetLeadDistributionDetails,
  setActivitiesCompletedThisWeek,
  setDashboardFilters,
  resetDashboardFilters,
} = actions;
export default slice.reducer;

